import { useMemo } from 'react';

import { useFlag } from '../../../services/launchDarkly';
import type { PocViewFactory, PocWizardConfig } from '../types';

import { initPocViewFactory } from './views/InitPocView/InitPocView';
import { pocProcessViewFactory } from './views/PocProcessView/PocProcessView';
import { pocStuckViewFactory } from './views/PocStuckView/PocStuckView';

export function usePocWizardConfig(skipImpressionStep?: boolean) {
  const pocEnabled = useFlag<boolean>('poc-enabled', false);

  return useMemo<PocWizardConfig>(() => {
    if (!pocEnabled) {
      return {
        steps: [],
        getStepsMapping: () => ({
          initPoc: -1,
          pocProcess: -1,
          pocStuck: -1,
        }),
      };
    }

    const steps: PocViewFactory[] = [];

    if (!skipImpressionStep) {
      steps.push(initPocViewFactory);
    }

    steps.push(pocProcessViewFactory, pocStuckViewFactory);

    return {
      steps,
      getStepsMapping: (stepBeforePoc) => ({
        initPoc: skipImpressionStep ? -1 : stepBeforePoc + steps.indexOf(initPocViewFactory) + 1,
        pocProcess: stepBeforePoc + steps.indexOf(pocProcessViewFactory) + 1,
        pocStuck: stepBeforePoc + steps.indexOf(pocStuckViewFactory) + 1,
      }),
    };
  }, [pocEnabled, skipImpressionStep]);
}
